import API from '@/api/index';

const notification = {
  state: {
  },

  mutations: {},

  actions: {
    SendMessage ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.notification
          .SendMessage(data)
          .then(response => {
            let result = response.data;
            if (!result.code) {
              resolve(result.data);
            } else {
              reject(result.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    GetNotifications ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.notification
          .GetNotifications(data)
          .then(response => {
            let result = response.data;
            console.log('GetNotifications -> result', result);
            if (!result.code || result.code === 'Successful') {
              resolve(result.data);
            } else {
              reject(result.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  }
};

export default notification;



// WEBPACK FOOTER //
// ./src/store/modules/notification.js